import React, {FC, useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react'
import ReactDOM from 'react-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import ComponentButton from '../ComponentButton'
import {TComponentDropdown} from './_types'

const GAP = 8
const clamp = (n: number, min: number, max: number) => Math.max(min, Math.min(n, max))

const PortalDropdown: FC<TComponentDropdown> = ({buttons}) => {
    const [show, setShow] = useState(false)
    const [pos, setPos] = useState({top: 0, left: 0})

    const toggleRef = useRef<HTMLButtonElement>(null)
    const menuRef = useRef<HTMLDivElement>(null)

    const computePos = useCallback(() => {
        const t = toggleRef.current
        const m = menuRef.current
        if (!t || !m) return
        const r = t.getBoundingClientRect()
        const mr = m.getBoundingClientRect()

        // имитация drop="start"
        let top = r.top + window.scrollY
        let left = r.left + window.scrollX - mr.width - GAP

        top = clamp(top, window.scrollY, window.scrollY + window.innerHeight - mr.height - GAP)
        left = clamp(
            left,
            window.scrollX + GAP,
            window.scrollX + window.innerWidth - mr.width - GAP
        )

        setPos({top, left})
    }, [])

    const toggle = useCallback(() => setShow((s) => !s), [])
    const close = useCallback(() => setShow(false), [])

    useLayoutEffect(() => {
        if (show) computePos()
    }, [show, computePos])

    useEffect(() => {
        if (!show) return
        const onEsc = (e: KeyboardEvent) => e.key === 'Escape' && close()
        const onClick = (e: MouseEvent) => {
            const path = (e.composedPath && e.composedPath()) || []
            if (!path.includes(menuRef.current as any) && !path.includes(toggleRef.current as any))
                close()
        }
        const onScroll = () => close()
        const onResize = () => computePos()

        window.addEventListener('keydown', onEsc)
        document.addEventListener('mousedown', onClick)
        window.addEventListener('scroll', onScroll, true)
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('keydown', onEsc)
            document.removeEventListener('mousedown', onClick)
            window.removeEventListener('scroll', onScroll, true)
            window.removeEventListener('resize', onResize)
        }
    }, [show, close, computePos])

    return (
        <>
            <button
                ref={toggleRef}
                type='button'
                className='componentDropdown_toggle'
                onClick={(e) => {
                    e.stopPropagation()
                    toggle()
                }}
            >
                <KTSVG path='/media/crm/icons/dots-vertical.svg' />
            </button>

            {show &&
                ReactDOM.createPortal(
                    <div
                        ref={menuRef}
                        className='dropdown-menu show componentDropdown_portalMenu'
                        style={{top: pos.top, left: pos.left}}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {buttons.map((button) => (
                            <a
                                key={`${button.type}-${button.settings.title}-${button.settings.icon}`}
                                className='dropdown-item'
                                role='button'
                                tabIndex={-1}
                                onClick={() => setShow(false)}
                            >
                                <ComponentButton {...button} className='moduleList_actionButton' />
                            </a>
                        ))}
                    </div>,
                    document.body
                )}
        </>
    )
}

export default PortalDropdown
